import axios from "axios";

const api = axios.create({
   baseURL: "https://api.farmfox.co/farmfox",
  //baseURL: "http://localhost:8080/farmfox",
  timeout: 10000
});

export default api;